module.exports = __webpack_public_path__ + "static/media/chevron_white.2b920f89.svg";